import { Client } from "../../../../types/global";

export default (clientContext: Array<Client>, id: string): Client => {
    const c = clientContext.find((c) => c.id === id) as Client
    return c
}